import { code } from "@spscommerce/utils";
import { DSReactExamples } from "@spscommerce/ds-shared";

export const SpsTagExamples: DSReactExamples = {
    basic: {
        label: "Basic Tag",
        examples: {
            basic: {
                jsx: code`
                    <SpsTag className="mr-1 mb-1">Default</SpsTag>
                    <SpsTag kind={TagKind.KEY} className="mr-1 mb-1">Key</SpsTag>
                    <SpsTag kind={TagKind.WARNING} className="mr-1 mb-1">Warning</SpsTag>
                    <SpsTag kind={TagKind.ERROR} className="mr-1 mb-1">Error</SpsTag>
                    <SpsTag kind={TagKind.PENDING} className="mr-1 mb-1">Pending</SpsTag>
                    <SpsTag kind={TagKind.SUCCESS} className="mr-1 mb-1">Success</SpsTag>
                    <SpsTag kind={TagKind.INFO} className="mr-1 mb-1">Info</SpsTag>
                `
            }
        }
    },
    withIcon: {
        label: "Tag with icon",
        examples: {
            basic: {
                jsx: code`
                    <SpsTag icon={SpsIcon.INFO_CIRCLE} className="mr-1 mb-1">Default</SpsTag>
                    <SpsTag icon={SpsIcon.CHECKMARK} kind={TagKind.KEY} className="mr-1 mb-1">Key</SpsTag>
                    <SpsTag icon={SpsIcon.EXCLAMATION_TRIANGLE} kind={TagKind.WARNING} className="mr-1 mb-1">Warning</SpsTag>
                    <SpsTag icon={SpsIcon.EXCLAMATION_CIRCLE} kind={TagKind.ERROR} className="mr-1 mb-1">Error</SpsTag>
                    <SpsTag icon={SpsIcon.ELLIPSES} kind={TagKind.PENDING} className="mr-1 mb-1">Pending</SpsTag>
                    <SpsTag icon={SpsIcon.CHECKMARK} kind={TagKind.SUCCESS} className="mr-1 mb-1">Success</SpsTag>
                    <SpsTag icon={SpsIcon.INFO_CIRCLE} kind={TagKind.INFO} className="mr-1 mb-1">Info</SpsTag>
                `
            }
        }
    }
};
